import React, { Component } from 'react'
import './assets/css/App.css';
// const circleSvg = `
// <svg width="473" height="457" viewBox="0 0 473 457" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M32.8937 354.042C19.0286 334.694 14.8993 311.598 10.727 288.957C3.15254 247.854 0.416957 205.677 3.00476 164.003C5.22579 128.236 15.8416 91.3861 38.5603 62.0481C66.1353 26.439 119.65 10.6845 163.727 4.5256C209.909 -1.92748 254.337 6.95245 298.449 19.5451C341.345 31.7905 379.568 51.085 413.005 79.4144C459.316 118.652 472.048 175.736 471.171 232.008C470.423 280.064 467.148 333.128 439.894 375.371C411.272 419.734 360.072 443.149 307.338 451.46C272.898 456.887 236.535 455.172 201.894 452.294C170.456 449.682 138.731 445.006 107.838 438.891C76.0668 432.603 46.552 421.435 18.8937 405.671" stroke="#D6FB00" stroke-width="3" stroke-linecap="round"/>
// </svg>

// `

// const lineSvg = `
// <svg width="508" height="58" viewBox="0 0 508 58" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M2.27686 18C39.0047 9.51145 75.4689 3.43721 113.277 2.55559C164.29 1.36605 215.49 7.39523 266.166 12.3334C343.124 19.8326 419.959 26.3186 497.166 30.5556C499.98 30.71 502.802 30.7593 505.61 31C506.169 31.0479 504.502 31.1726 503.944 31.2223C493.057 32.1899 482.078 31.9105 471.166 32.2223C407.594 34.0386 344.287 41.4055 281.055 47.6667C251.628 50.5805 222.153 52.9739 192.61 54.3334C185.848 54.6445 170.666 57.3836 163.721 53.7778C161.9 52.8321 168.134 49.403 168.499 49.2223C175.583 45.7183 184.262 44.6262 191.944 43.4445C201.002 42.0509 210.214 41.0771 219.388 41C221.035 40.9862 224.113 40.6892 225.61 41.7778C226.32 42.2942 223.67 42.2147 223.277 43" stroke="#D6FB00" stroke-width="3" stroke-linecap="round"/>
// </svg>
// `

class App extends Component {
    render() {
        return (
            <>
            <header>
                <div className="inner">
                    <div className="header-logo">
                        <img src={require("./assets/images/logo.png")} alt="docusign logo" />
                    </div>
                    <div className="header-verbiage">
                        <p>The Official DocuSign Store</p>
                    </div>
                </div>
               
            </header>
            <div className="wrapper">
                <div className="section-a">
                    <div className="inner">
                        <div className="verbiage">
                            <img width="50px" height="auto" src={require("./assets/images/logo-icon.png")} alt="docusign logo icon" />
                            <h1>Made for you</h1>
                            <p>
                                From workweek essentials to weekend adventures, get quality DocuSign gear designed to last. 
                                Simple, sustainable and cool enough you'll definitely want to rock it.
                            </p>
                        </div>
                        <div className="btns">
                            <a href="https://docusign-newhire.mybrightsites.com/" className="btn-box">
                                <div className="specific-icon">
                                    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path d="M18.5 21.625V19.375C18.5 18.1815 18.0259 17.0369 17.182 16.193C16.3381 15.3491 15.1935 14.875 14 14.875C10.8313 14.875 5.46104 13.675 2.94302 16.193C2.09911 17.0369 1.625 18.1815 1.625 19.375V21.625" stroke="#191823" stroke-width="2.25"/>
                                        <path d="M9.5 10.375C11.9853 10.375 14 8.36028 14 5.875C14 3.38972 11.9853 1.375 9.5 1.375C7.01472 1.375 5 3.38972 5 5.875C5 8.36028 7.01472 10.375 9.5 10.375Z" stroke="#191823" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div className="btn-verbiage">
                                    <h4>New Hires</h4>
                                    <p>Welcome to DocuSign! Choose your free merch.</p>
                                </div>
                                <div className="arrow-right">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 0.292879L15.7071 6.29288C16.0976 6.6834 16.0976 7.31657 15.7071 7.70709L9.70711 13.7071L8.2929 12.2929L12.5858 7.99999L1.34755e-06 7.99999L9.97862e-07 5.99999L12.5858 5.99999L8.29289 1.70709L9.70711 0.292879Z" fill="#191823"/>
                                    </svg>
                                </div>
                            </a>
                            <a href="https://docusign.mybrightsites.com/" className="btn-box">
                                <div className="specific-icon">
                                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path d="M21 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H21C22.1046 17 23 16.1046 23 15V3C23 1.89543 22.1046 1 21 1Z" stroke="#191823" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 7H23" stroke="#191823" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div className="btn-verbiage">
                                    <h4>Personal Shop</h4>
                                    <p>Want even more merch? Shop with your personal credit card.</p>
                                </div>
                                <div className="arrow-right">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 0.292879L15.7071 6.29288C16.0976 6.6834 16.0976 7.31657 15.7071 7.70709L9.70711 13.7071L8.2929 12.2929L12.5858 7.99999L1.34755e-06 7.99999L9.97862e-07 5.99999L12.5858 5.99999L8.29289 1.70709L9.70711 0.292879Z" fill="#191823"/>
                                    </svg>
                                </div>
                            </a>
                            <a href="https://docusign.mybrightsites.com/pages/35064" className="btn-box">
                                <div className="specific-icon">
                                    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path d="M13 12H5" stroke="#191823" stroke-width="2"/>
                                        <path d="M11 1C8.73787 1 1 1 1 1C1 1 1 16.8531 1 21H17C17 21 17 9.96545 17 7L11 1Z" stroke="#191823" stroke-width="2"/>
                                        <path d="M11 1V7H17" stroke="#191823" stroke-width="2" stroke-linecap="round"/>
                                        <path d="M13 16H5" stroke="#191823" stroke-width="2"/>
                                    </svg>
                                </div>
                                <div className="btn-verbiage">
                                    <h4>Corporate Orders</h4>
                                    <p>Shopping for your department, customer or partner? Order via PO.</p>
                                </div>
                                <div className="arrow-right">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-icon">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 0.292879L15.7071 6.29288C16.0976 6.6834 16.0976 7.31657 15.7071 7.70709L9.70711 13.7071L8.2929 12.2929L12.5858 7.99999L1.34755e-06 7.99999L9.97862e-07 5.99999L12.5858 5.99999L8.29289 1.70709L9.70711 0.292879Z" fill="#191823"/>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-b">
                <div className="inner">
                    <div className="big-stock">
                        <img  src={require("./assets/images/boy-smile.png")} alt="employee man smiling" />
                    </div>
                    <div className="small-stock">
                        <img  src={require("./assets/images/girl-roof.png")} alt="employee woman on roof" />
                    </div>
                </div>
            </div>
            <footer>
                <div className="inner">
                    <div className="left">
                        <img src={require("./assets/images/ds-store.png")} alt="docusign logo" />
                        <a href="https://www.canarymarketing.com" target="_blank" rel="noreferrer">Powered by Canary</a>
                    </div>
                    <div className="right">
                        <a href="https://docusign.mybrightsites.com/" target="_blank" rel="noreferrer">Home</a>
                        <a href="https://docusign.mybrightsites.com/account/dashboard" target="_blank" rel="noreferrer">My Account</a>
                        <a href="https://docusign.mybrightsites.com/pages/18736" target="_blank" rel="noreferrer">FAQ</a>
                        <a href="https://docusign.mybrightsites.com/pages/18737" target="_blank" rel="noreferrer">Contact Us</a>
                        <a href="https://docusign.mybrightsites.com/pages/35064" target="_blank" rel="noreferrer">Corporate Orders</a>
                    </div>
                </div>
            </footer>
            </>
        )
    }
}

export default App;


